import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotificationContext } from '../../providers/NotificationProvider';
import { DashboardSection } from '../../components/DashboardSection/DashboardSection';
import { InventoryCard } from '../../components/Card/InventoryCard';
import { DonutChart } from '../../components/DonutChart';
import { WelcomeModal } from '../../components/modals/WelcomeModal';
import { getSessionVar } from '../../lib/helpers';
import classNames from 'classnames';

import './Home.scss';

export const MigrationDashboard = ({ migrationData, backupData, disasterRecoveryData, getUserRole }) => {
    const navigate = useNavigate();
    const { notifyError } = useNotificationContext();

    const pageData = [migrationData, backupData, disasterRecoveryData];
    const [welcomeModalVisible, setWelcomeModalVisible] = useState(false);
    const isAdmin = getUserRole() === 'ADMIN' || getUserRole() === 'ORG_ADMIN';
    const actionsAreAllowed = getUserRole() !== 'GLOBAL_ADMIN';

    useEffect(() => {
        let user = getSessionVar('user');
        let displayWelcomeModal = getSessionVar('displayWelcomeModal');
        if (user?.show_intro && displayWelcomeModal) setWelcomeModalVisible(true);
    }, []);

    const handleCardClick = (link) => {
        if (!actionsAreAllowed) return;

        if (link === '/projects' && isAdmin) {
            navigate(link);
        } else if (link === '/projects' && !isAdmin) {
            notifyError({ description: 'You do not have permission to access this page.' });
        } else {
            navigate(link);
        }
    };

    return (
        <>
            {pageData
                .filter((block) => Boolean(block) && !block.hideBlock)
                .map((data, index) => (
                    <DashboardSection title={data.title} key={index}>
                        <div className="dashboard-content-wrapper">
                            <div className="chart-card">
                                <DonutChart
                                    used={data.used}
                                    remaining={data.available}
                                    chartLabels={data.chartLabels}
                                />
                            </div>
                            <div className="inventory-cards-grid">
                                {data.stats.map((stat, statIndex) => (
                                    <InventoryCard
                                        key={statIndex}
                                        title={stat.title}
                                        content={[{ text: stat.value, type: 'primary' }]}
                                        isExpanded={true}
                                        onClick={() => handleCardClick(stat.link)}
                                        className={classNames({ clickable: actionsAreAllowed })}
                                    />
                                ))}
                            </div>
                        </div>
                    </DashboardSection>
                ))}
            <WelcomeModal open={welcomeModalVisible} onCancel={() => setWelcomeModalVisible(false)} />
        </>
    );
};
